import { Identifiable, ProjectPortfolio } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByProjectPortfolios(
  projectPortfolio: Identifiable<ProjectPortfolio>,
  { projectPortfolios }: Filter,
): boolean {
  return (
    !!projectPortfolios &&
    projectPortfolios.length > 0 &&
    !projectPortfolios.find(({ uuid }) => uuid === projectPortfolio.uuid)
  );
}

export { isFilteredByProjectPortfolios };
